// Permission selector Jquery plugin
define('commons/perm-selector',['jquery', 'commons/element-selector', 'commons/live-search-field'], function($, ElementSelector) {

    var onOk = function() {
        if ($.isFunction(this.settings.onOkClick)) {
            var selectedArray = this.elementSelector.model.selected.asArray();
            if (confirm("You have selected " + selectedArray.length + " elements. Continue?")) {
                this.settings.onOkClick.call(this, selectedArray);
            }
        }
    };

    var loadData = function() {
        this.loaded = true;
        this.permPopupContent.addClass("loading");
        $.ajax({
            type: 'GET',
            url: this.settings.listUrl,
            dataType: "html",
            success: function(data) {
                pageLoaded.call(this, data);
            },
            context: this
        });
    };

    var pageLoaded = function(data) {
        this.elementSelector.beforeDataLoaded();
        this.permPopupContent.html(data);
        this.permPopupContent.removeClass("loading");
        this.elementSelector.onDataLoaded.apply(this.elementSelector);
        return false;
    };

    var methods = {
        init: function(options) {
            this.settings = {
                dialogOptions: {
                    'autoOpen': false,
                    'resizable': true,
                    'minWidth': 400,
                    'width': '30%',
                    'height': 450,
                    'zindex': 100,
                    'draggable': true,
                    'dialogClass': 'list-selector-dialog',
                    'modal': true
                },
                refresh: false,
                filter: {
                    parameter: 'id',
                    placeholder: 'perm id'
                },
                prefix: "#perm",
                onOkClick: null,
                suffix: false
            };
            $.extend(true, this.settings, options);
            this.loaded = false;
            this.name = "";
            this.id = this.settings.suffix ? '_' + this.settings.suffix : '';
            // Create toolbar
            this.permPopup = this.first().dialog(this.settings.dialogOptions);
            this.permPopup.dialog("option", "title", this.settings.title);
            var cont = $(this.permPopup.dialog("widget").find(".ui-dialog-content"));
            cont.append("<div id='toolbar' class='toolbar top-fixed'>" + "<input type='search' placeholder='" + this.settings.filter.placeholder +
                    "' id='idFilter" + this.id + "' />" + "<a href='#' class='toolbar-button validate' id='okButton" + this.id + "'>Ok</a>" +
                    "</div>");
            this.elementSelector = new ElementSelector(cont, {
                suffix: this.id
            });
            cont.find("#okButton" + this.id).click($.proxy(onOk, this));
            cont.find("#idFilter" + this.id).liveSearch({
                searchUrl: this.settings.listUrl,
                valueParameter: this.settings.filter.parameter,
                successCallback: $.proxy(pageLoaded, this)
            });
            cont.append('<div id="permcontent' + this.id + '" class="permListContent"></div>');
            // get content
            this.permPopupContent = cont.find("#permcontent" + this.id);
            return this;
        },
        open: function() {
            this.permPopup.dialog("open");
            if (!this.loaded || this.settings.refresh) {
                loadData.apply(this);
            }
        },
        close: function() {
            this.permPopup.dialog("close");
        }
    };

    $.fn.permSelector = function(method) {
        // Method calling logic
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.tooltip');
        }
        return this;
    };

});
